var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pill",class:_vm.type,on:{"click":_vm.openStockPage}},[_vm._v(_vm._s(_vm.typeName)+": "+_vm._s(_vm.item.value)+" \n"),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(this.$t('building_page.UNITS')))])])}
var staticRenderFns = []

export { render, staticRenderFns }